import { render, staticRenderFns } from "./integral-deduction.vue?vue&type=template&id=8725de34&scoped=true&"
import script from "./integral-deduction.vue?vue&type=script&lang=js&"
export * from "./integral-deduction.vue?vue&type=script&lang=js&"
import style0 from "./integral-deduction.vue?vue&type=style&index=0&id=8725de34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8725de34",
  null
  
)

export default component.exports